import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";

import React from "react";
import { AspectRatio } from "../../../_shared-components/image-related/AspectRatio";
import { ImageWithFocalPoint } from "../../../_shared-components/image-related/ImageWithFocalPoint";
import {
  StyledStoryEmoHeadline,
  StyledStorySeoHeadline,
  StyledStoryTagsList,
  StyledStoryTime,
} from "../../elements/styled-elements";
import { SwarovskiLink } from "../../../_shared-components/ui-elements/SwarovskiLink";
import { pipe } from "fp-ts/lib/function";
import { nonEmptyArray, option } from "fp-ts";
import { ExpandedStoryTeaser } from "../../../../layouts/stories/stories-overview-page/stories-overview-page-layout";
import { EXPERIMENTAL_TextWithProductNameRenderer } from "../../../../domain/swarovski-optik/products/product-name/product-name-renderer";
import { T } from "../../../T";

export const StoriesOverviewSmallTeaser: ReactTFC<{
  teaser: ExpandedStoryTeaser;
  portraitImage?: boolean;
}> = ({ teaser, portraitImage }) => {
  const imageAspectRatio = portraitImage ? { height: 1.3, width: 1 } : { height: 0.8, width: 1 };

  return (
    <React.Fragment>
      <SwarovskiLink link={teaser.link} isInternal={true} scrollToTop={true} styled={"no-decoration"}>
        <AspectRatio {...imageAspectRatio}>
          <ImageWithFocalPoint
            {...teaser.imageWithFocalPoint}
            requestedWidth={600}
            assetId={teaser.imageWithFocalPoint.image.sys.id}
          />
        </AspectRatio>

        <StyledStorySeoHeadline>
          <EXPERIMENTAL_TextWithProductNameRenderer text={teaser.seoHeadline} />
        </StyledStorySeoHeadline>

        <StyledStoryEmoHeadline>
          <EXPERIMENTAL_TextWithProductNameRenderer text={teaser.emoHeadline} />
        </StyledStoryEmoHeadline>
      </SwarovskiLink>

      {pipe(
        teaser.tags,
        nonEmptyArray.fromArray,
        option.map(tags => <StyledStoryTagsList tags={tags} />),
        option.getOrElseW(() => null),
      )}

      <StyledStoryTime>
        <T>{teaser.readingTime}</T>
      </StyledStoryTime>
    </React.Fragment>
  );
};
